import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-carbon relative overflow-hidden" data-id="element-10">
      {/* Subtle background glow for CTA emphasis */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-11" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-13">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold mb-10 leading-tight" data-id="element-14">
            Cada hora con la silla vacía es dinero que no vuelve.
          </h2>

          <CTAButton className="w-full md:w-auto text-xl py-5 px-10 mb-6" data-id="element-15">
            LLENA MI AGENDA AHORA
          </CTAButton>

          <p className="text-gray-400 text-sm md:text-base max-w-lg mx-auto leading-relaxed" data-id="element-16">
            Cupos limitados por zona geográfica. Solo trabajamos con un salón
            por ciudad para evitar conflictos.
          </p>
        </motion.div>
      </div>
    </section>;
}